<div class="bp-modal mod-lg" [class.elevated]="showGreyBackground() && !isThirdStep">
  @if (showTradeFlow$ | async) {
    @if (currentStep; as header) {
      <legacy-order-header
        [priceSubject$]="priceSubject$"
        [offer]="data"
        [cameFromHeaderSwitch]="cameFromHeaderSwitch"
        class="font-semibold"
        [title]="header.title">
        @if (header.left; as left) {
          <a
            left
            (click)="onHeaderButtonClick(left)"
            (keydown.enter)="onHeaderButtonClick(left)"
            [tabIndex]="0">
            {{ left | translate }}
          </a>
        }
        @if (header.right; as right) {
          <a
            right
            (click)="onHeaderButtonClick(right)"
            (keydown.enter)="onHeaderButtonClick(right)"
            [tabIndex]="0">
            {{ right | translate }}
          </a>
        }
      </legacy-order-header>
    }
    @if ({ active: cashPlusFF$ | async }; as cashPlusFF) {
      <div class="bp-modal-body">
        <div
          class="bp-modal-body-section"
				[ngClass]="{
					'pb-0 mod-trade-flow': isWalletStackSelection() || isThirdStep,
					'mod-no-padding': isTradableListSelection()
				}">
          <div
					[ngClass]="{
						'bp-modal-description': isWalletStackSelection() || isSecondStep,
						'text-center pb-20 text-summary-description': isThirdStep
					}">
            @if (isWalletStackSelection()) {
              {{ "tradable_wallet_selection_stack_header" | translate }}
            }
            @if (isSecondStep) {
              {{ "buy_choose_depot" | translate }}
            }
          </div>
          <!--
          *
          *   SELECT WALLET
          *
          -->
          @if (hasFiatFunds && isFirstStep) {
            <!-- legacy logic: with `tradableId` we communicate that we have multiple wallets -->
            <!-- `tradableId` = null -> we don't have multiple wallets -->
            <!-- `tradableId` != null -> we have multiple wallets -->
            @if (!tradableId) {
              <buy-asset-list
                (assetClicked)="onTradableSelect($event.tradable, cashPlusFF.active)"
                [isPriceOrder]="isLimitOrder">
              </buy-asset-list>
            }
            @if (tradableId) {
              <tradable-wallet
                [ngClass]="'modal-grid mod-two-cols'"
                [action]="'buy'"
                [tradableWallets]="wallets"
                (onSelect)="onWalletSelect($event, cashPlusFF.active)"
                [(tradableId)]="tradableId">
              </tradable-wallet>
            }
          }
          <!--
          *
          *   SELECT ACCOUNT
          *
          -->
          @if (isSecondStep) {
            <div class="modal-grid mod-two-cols">
              <!-- cashplus wallet -->
              @if (cashPlusFiatTilesVM$ | async; as vm) {
                @for (asset of vm; track asset) {
                  <cashplus-fiat-tile
                    [asset]="asset"
                    [defaultFiat]="asset.defaultFiat"
                    [isCashPlusOptIn]="asset.isOptIn"
                    [isCashPlusEligible]="asset.isEligible"
                    (click)="selectCashPlusFiatWallet(asset)"
                    (keydown.enter)="selectCashPlusFiatWallet(asset)"
                    class="grid-item card-interactive">
                  </cashplus-fiat-tile>
                }
              } @else {
                @for (fw of getFiatWallets(); track fw; let i = $index) {
                  <fiat-wallet-tile
                    [wallet]="fw"
                    [ngClass]="'grid-item'"
                    (keydown.enter)="selectFiatWallet(fw)"
                    (click)="selectFiatWallet(fw)"
                    tabindex="50+i"
                  [active]="isSame(fw, fiatWallet)"></fiat-wallet-tile>
                }
              }
              <!-- normal wallet -->
              <!-- normal wallet -->
            </div>
          }
          <!--
          *
          *   AMOUNTS
          *
          -->
          @if (priceSubject$ | async) {
            <div class="modal-grid mod-three-cols mod-in-modal mod-center">
              @for (conversion of getAmounts(); track conversion) {
                <tradable-amount-tile
                  [ngClass]="'grid-item'"
                  [bfcOptIn]="data?.bestFeeOptIn"
                  (keydown.enter)="setAmount(conversion)"
                  (click)="setAmount(conversion)"
                  [fiat]="getFiat()"
                  [showSmallAmount]="!isIndexTrade()"
                  [conversion]="conversion"
                  [tradable]="getTradable()">
                </tradable-amount-tile>
              }
              <tradable-amount-tile
                [ngClass]="'grid-item'"
                (keydown.enter)="setToMax()"
                (click)="setToMax()"
                [bfcOptIn]="data?.bestFeeOptIn"
                [conversion]="maxAmount()"
                [all]="true"
                [inverse]="true"
                [fiat]="getFiat()"
              [tradable]="getTradable()"></tradable-amount-tile>
            </div>
          }
        </div>
        @if (priceSubject$ | async; as defaultPrice) {
          <div class="bp-modal-body-section mod-fullwidth pt-30" [ngClass]="{ 'pb-15': showDerivativeFooter() }">
            <div class="items-start flex-wrap modal-internal-transfer mod-input">
              <bp-input
                class="mod-input-line"
                iconLeading="true"
                [type]="getSelectedCurrency()"
                [iconUrl]="icon"
                [iconUrlAltText]="'logo_alt_text' | translate"
                min="0"
                name="amount_fiat"
                (keydownEnter)="getOffer()"
                [step]="getStepsFromOfferFiat()"
                required
                autofocus
                [(value)]="amount"
                [formGroupClass]="false"
                (onFocus)="inputOnFocus($event)"
                (onFocusOut)="inputOnFocusOut($event)"
                (valueChange)="inputModelChange($event)"
                bpInputNumberLeadingTrailingDot
                [trailingDotPrecision]="userWantsTradable ? getTradable().getPrecision() : 2">
                @if (!isIndexTrade()) {
                  <a
                    right
                    (click)="change()"
                    class="hover-pointer"
                    href="javascript:"
                    >
                    @if (isNotIndexNorTokenTrade()) {
                      <span
										[ngClass]="{
											'text-transparent font-size-13': !userWantsCrypto,
											'text-highlight font-size-17': userWantsCrypto
										}">
                        <span>{{ getTradable()?.getSymbol() }}</span>
                      </span>
                      /
                      <span
										[ngClass]="{
											'text-transparent font-size-13': userWantsCrypto,
											'text-highlight font-size-17': !userWantsCrypto
										}">
                        {{ getFiat()?.getSymbol() }}
                      </span>
                    } @else {
                      <img src="{{ getTradable().getLogo() }}" [class.selected-icon]="userWantsCrypto" />
                      /
                      <img src="{{ getFiat().getLogo() }}" [class.selected-icon]="!userWantsCrypto" />
                    }
                  </a>
                }
              </bp-input>
            </div>
            <!-- labels: min amount + fees info -->
            <div class="bp-modal-row mt-10 bp-modal-custom-margin modal-internal-transfer mod-input">
              <div class="bp-modal-column left">
                {{ "minimum" | translate }}:
                {{ min | fiat_precision_symbol: { id: getFiat()?.getId(), currencies: [getFiat()] } }}
              </div>
              @if (!isIndexTrade()) {
                <div class="bp-modal-column right text-gray">
                  {{ 1 | tradable_precision_symbol: { id: getTradable().getId(), removePrecision: true } }}
                  &asymp;
                  {{
                  getPriceFiat()
                  | fiat_precision_symbol
                  : { id: getFiat()?.getId(), currencies: [getFiat(), getTradable()] }
                  }}
                </div>
              }
            </div>
            <!-- Leveraged info amount screen -->
            @if (isLeveragedToken()) {
              <div class="l-token-info-wrapper">
                <leveraged-token-info-amount
                  [vm]="leverageTokenViewModel$ | async"
                  [amountInput]="getAmountFiat()"
                  [cfdEnabled]="cfdEnabled$ | async">
                </leveraged-token-info-amount>
              </div>
            }
            <!-- BCI CashPlus info box -->
            @if (isIndexTrade()) {
              @if ((cashPlusPortfolioForFiat$ | async)?.parked_asset_balance > 0) {
                <div class="bci-cashplus-info">
                  <bp-info-box>
                    <div>
                      <span>{{ "cashplus_bci_infobox_text" | translate }} </span>
                      <a (click)="goToFiatWallet()">{{ "go-to-wallet" | translate }}</a>
                    </div>
                  </bp-info-box>
                </div>
              }
            }
            <!-- Info box -->
            <instant-trade-bonus [step]="getItbStep()" [tradeData]="getItbData()"></instant-trade-bonus>
            <hr class="mb-20 mt-30" />
            <div class="pl-50 pr-50">
              @if (!isIndexTrade()) {
                <div
                  class="bp-modal-row font-size-24"
								[ngClass]="{
									'text-light': data?.getAmountTradable() === 0
								}">
                  <div class="bp-modal-column left mr-5">{{ "amount_total" | translate }}</div>
                  <div class="bp-modal-column right break">
                    <strong>
                      {{
                      getAmountTradable()
                      | tradable_precision_symbol
                      : {
                      id: getTradable()?.getId(),
                      ignorePrecision: true
                    }
                    }}
                  </strong>
                </div>
              </div>
              <div class="bp-modal-row font-size-15">
                <div class="bp-modal-column left text-opaque"></div>
                <div class="bp-modal-column right break color-black">
                  &asymp;
                  {{
                  getAmountFiat()
                  | fiat_precision_symbol: { id: getFiat()?.getId(), currencies: [getFiat()] }
                  }}
                </div>
              </div>
            } @else {
              <div
                class="bp-modal-row font-size-24"
								[ngClass]="{
									'text-light': data?.getAmountTradable() === 0
								}">
                <div class="bp-modal-column left mr-5">{{ "amount" | translate }}</div>
                <div class="bp-modal-column right break">
                  <strong>
                    {{
                    getAmountTradable()
                    | fiat_precision_symbol
                    : { id: getFiat()?.getId(), currencies: [getFiat()], symbol: true }
                    }}
                  </strong>
                </div>
              </div>
            }
          </div>
          <div class="pl-30 pr-30 mt-20 text-center">
            <button
              class="btn btn-primary btn-lg btn-summary mod-amount"
              type="button"
              (click)="getOffer()">
              {{ "goto_summary_trade_buy_button" | translate }}
            </button>
          </div>
          @if (showDerivativeFooter()) {
            <div class="trade-modal_powered_by_stocks">
              {{ "stocks_powered_by" | translate }}
            </div>
          }
        </div>
      }
    </div>
  }
} @else {
  <tradable-trade-summary
    [data]="data"
    [shouldCallGql]="shouldCallGql()"
    [itbData]="getItbData()"
    [cashPlusAsset]="selectedCashPlusWallet"
    [isCashPlus]="cashPlusFF$ | async"
    [showAppTestWarning]="getAppTestTradingWarning()"
    (onClose)="closeFromError($event)"
    (edit)="setEdit($event)"
    (finish)="showSuccessScreen($event)"
    (onReceiveTradeId)="updateTradeId($event)">
  </tradable-trade-summary>
}
</div>
